import React from 'react';
import { graphql } from 'gatsby';
import Maps from 'gatsby-theme-core/src/components/maps';
import Page from './page';

export const pageQuery = graphql`
  query EaContactPageById($id: ID!) {
    strapi {
      page(id: $id) {
        content
        form {
          ...StrapiForm
        }
        ...PagesPageHead
      }
    }
  }
`;

const EaContactPage = (props) => (
  <Page {...props} disablePageImage>
    <Maps />
  </Page>
);

export default EaContactPage;
